import { Badge, Icon, Tooltip } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const STATUSES = {
  updated: {
    icon: 'status active',
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
    label: 'campaigns_editor::budget_editor.table.rows.badge.updated',
  },
  error: {
    icon: 'status warning',
    color: 'Label-Error-Primary',
    bgColor: 'Background-Error',
    label: 'campaigns_editor::budget_editor.table.rows.badge.error',
  },
}

const AVAILABLE_ERRORS = [
  'has_no_budget',
  'end_before_start',
  'total_budget_requires_end',
  'group_dates_out_of_campaign_dates',
  'date_in_past',
  'empty_dates',
  'has_no_dates',
  'internal_server_error',
  'not_found',
]

const Wrapper = ({ error, children, placement = 'top' }) => {
  const { t } = useTranslation()

  return error && AVAILABLE_ERRORS.includes(error) ? (
    <Tooltip
      title={t(`campaigns_editor::budget_editor.table.rows.error.${error}`)}
      placement={placement}
      arrow
    >
      {children}
    </Tooltip>
  ) : (
    children
  )
}

Wrapper.propTypes = {
  error: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
  children: PropTypes.elementType,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
}

export const StatusBadge = ({
  rowState: { error = null, errors = null, updated = false } = {},
  placement = 'top',
}) => {
  const status = useMemo(
    () => (error || errors ? 'error' : updated ? 'updated' : ''),
    [error, errors, updated],
  )

  const currentStatus = STATUSES?.[status]
  const { t } = useTranslation()

  if (!currentStatus) {
    return null
  }

  const { icon, label, bgColor, color } = currentStatus

  return (
    <Wrapper error={error} placement={placement}>
      <Badge
        bgColor={bgColor}
        color={color}
        startIcon={<Icon color={color} name={icon} width={16} />}
      >
        {t(label)}
      </Badge>
    </Wrapper>
  )
}

StatusBadge.propTypes = {
  rowState: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
    errors: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.object]),
    updated: PropTypes.bool,
  }),
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
}
